import { Card, Tabs, Avatar, Badge, Box, Collapsible, Button, ButtonGroup, DataTable, Divider, InlineGrid, InlineStack, Icon, Link, MediaCard, Modal, Page, Spinner, Tag, Text, TextField, Tooltip, BlockStack, VideoThumbnail, Popover, ActionList, Checkbox } from "@shopify/polaris";
import { getBestAvatar, getCountry, shortenNumber, daysAgo, getPaymentDueSummary } from "../../utils";
import { HeartIcon, DeleteIcon, ViewIcon, CheckIcon, LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon, ChatIcon, PersonIcon, PlayIcon, PersonRemoveIcon, ImagesIcon, SendIcon, ExternalIcon, HideIcon, DisabledIcon, SmileyJoyIcon, ChevronUpIcon, ChevronDownIcon, OrderIcon, CashDollarIcon, ClockIcon, EmailNewsletterIcon, ArrowLeftIcon } from '@shopify/polaris-icons';
import { useEffect, useMemo, useState } from "react";
// import { AddressElement } from "@stripe/react-stripe-js";
// import BucketButton from "../leads/BucketButton";
// import ManageBuckets from "../leads/ManageBuckets";
// import PostsLibrary from "../content/PostsLibrary";
import { usePartnerUp } from "../../providers/PartnerUpStoreProvider";
import { doc, setDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import BucketButton from "../BucketButton";
import ManageBuckets from "../ManageBuckets";

function StatsCard({ icon, title, value, subValue }) {
  return (
    <Card>
      <BlockStack gap="200">
        <InlineStack align="start">
          <InlineStack>
            <Icon source={icon} color="subdued" />
          </InlineStack>
        </InlineStack>
        <BlockStack>
          <Text>{title}</Text>
          <InlineStack align="space-between" blockAlign="end">
            <Text variant="headingMd">{value}</Text>
            {
              subValue ? (
                <Text variant="bodySm">{subValue}</Text>
              ) : null
            }
          </InlineStack>
        </BlockStack>
      </BlockStack>
    </Card>
  )
}

export default function SearchProfile({
  saveCreator,
  setCreatorOpen,
  profileData
}) {
  const { setToast, user, db, localSeen, setLocalSeen } = usePartnerUp()
  const [customerFiltersOpen, setCustomerFiltersOpen] = useState(false)

  function getTargetFollowers(followers) {
    if (!followers) {
      return followers
    }
    const targetCustomers = user?.filters
    if (!user?.filters) {
      return followers
    }
    const ageWeights = targetCustomers?.ageGroups?.length ? profileData?.ages?.reduce((acc, ageStat) => {
      if (targetCustomers.ageGroups.includes(ageStat.code)) {
        acc += (ageStat.weight || 0)
      }
      return acc
    }, 0) : 1
    const genderWeights = targetCustomers?.genders?.length ? profileData?.genders?.reduce((acc, genderStat) => {
      if (targetCustomers.genders?.includes(genderStat.code)) {
        acc += (genderStat.weight || 0)
      }
      return acc
    }, 0) : 1
    const countryWeights = targetCustomers?.countries?.length ? profileData?.geoCountries?.reduce((acc, countryStat) => {
      if (targetCustomers.countries.includes(countryStat.name)) {
        acc += (countryStat.weight || 0)
      }
      return acc
    }, 0) : 1

    const credibility = profileData?.credibility || 1

    return followers * ageWeights * genderWeights * countryWeights * credibility
  }

  const targetFollowers = getTargetFollowers(profileData?.followers)

  const [saveLoading, setSaveLoading] = useState(false)
  const [manageBucketsOpen, setManageBucketsOpen] = useState(false)


  const [changeBuckets, setChangeBuckets] = useState(null)

  const [hideLoading, setHideLoading] = useState(false)
  const [localHidden, setLocalHidden] = useState(profileData?.hidden)

  console.log('profileData', profileData)

  useEffect(() => {
    if (user && profileData) {
      if (!profileData?.seen) {
        console.log('marking seen')
        try {
          setDoc(doc(db, 'usersV2', user?.id, 'creators', profileData?.id), { seen: true }, { merge: true })
          setLocalSeen({ ...localSeen, [profileData?.id]: true })
        } catch (e) {
          console.error('error marking seen', e)
        }
      }
    }
  }, [profileData])

  console.log('profile', profileData)

  async function hide(hide = true) {
    alert('todo')
  }


  if (Array.isArray(profileData?.customFields)) {
    profileData.customFields = profileData.customFields.reduce((acc, field) => {
      acc[field.key] = field.value
      return acc
    }, {})
  }

  console.log('targetFollowers', targetFollowers)


  return (
    <>
      <ManageBuckets open={manageBucketsOpen} onClose={() => setManageBucketsOpen(false)} />
      <BlockStack gap="500">
        <InlineGrid columns="1fr 2fr" gap="500">
          <BlockStack gap="500">
            <Text variant="headingLg">Profile</Text>
            <InlineGrid columns="1" gap="500">
              {
                localHidden || profileData?.hidden ? (
                  <MediaCard
                    size="small"
                    primaryAction={{
                      content: 'Un-Hide Creator',
                      loading: hideLoading,
                      onAction: () => hide(false)
                    }}
                    description={'Un-Hide to Invite & Manage This Creator'}
                    title={
                      <BlockStack inlineAlign="start">
                        <InlineStack gap="100">
                          <Text variant="headingLg">
                            {'Creator is Hidden'}
                          </Text>
                        </InlineStack>
                      </BlockStack>
                    }>
                    {
                      <div style={{
                        backgroundImage: `url("")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '150px'
                      }} />
                    }
                  </MediaCard>
                ) : profileData?.status === 'newLead' ? (
                  <MediaCard
                    size="small"
                    primaryAction={{
                      content: 'Save Creator',
                      loading: saveLoading,
                      onAction: async () => {
                        try {
                          setSaveLoading(true)
                          const creatorID = await saveCreator({
                            ...profileData,
                            creatorID: profileData?.id,
                            email: profileData?.email
                          })
                          setCreatorOpen(creatorID)
                        } catch (e) {
                          setToast({ content: e.message, error: true })
                        } finally {
                          setSaveLoading(false)
                        }
                      }
                    }}
                    secondaryAction={{
                      content: 'Hide Creator',
                      loading: hideLoading,
                      onAction: () => {
                        hide(true)
                      }
                    }}
                    description={'What do you want to do with this creator?'}
                    title={
                      <BlockStack inlineAlign="start">
                        <InlineStack gap="100">
                          <Text variant="headingLg">
                            {'Actions'}
                          </Text>
                        </InlineStack>
                      </BlockStack>
                    }>
                    {
                      <div style={{
                        backgroundImage: `url("")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '150px'
                      }} />
                    }
                  </MediaCard>
                ) : profileData?.email ? (
                  <></>
                ) : !profileData?.email && !profileData?.contacts?.find(contact => contact.type === 'email')?.value ? (
                  <></>
                ) : null
              }
              <Card>
                <BlockStack gap="200">
                  <InlineStack align="space-between">
                    <Text variant="headingMd">Email</Text>
                    <InlineStack>
                      {
                        profileData?.email || profileData?.contacts?.find(contact => contact.type === 'email')?.value ? (
                          <Icon source={CheckIcon} color="success" />
                        ) : (
                          <Icon source={DisabledIcon} color="subdued" />
                        )
                      }
                    </InlineStack>
                  </InlineStack>
                  <InlineStack align="space-between" blockAlign="center">
                    <Text variant="bodyMd">{profileData?.email || 'No Email'}</Text>
                  </InlineStack>
                </BlockStack>
              </Card>
              <InlineGrid columns={{ xs: "1", md: "2" }} gap="500">
                <Card>
                  <BlockStack gap="200">
                    <Text variant="headingMd">Country</Text>
                    <InlineStack align="space-between" gap="200">
                      <Text>{getCountry(profileData?.country)}</Text>
                    </InlineStack>
                  </BlockStack>
                </Card>
                <Card>
                  <BlockStack gap="200">
                    <Text variant="headingMd">Age</Text>
                    <InlineStack align="space-between" gap="200">
                      <Text>{profileData?.ageGroup}</Text>
                    </InlineStack>
                  </BlockStack>
                </Card>
              </InlineGrid>
              <Card>
                <BlockStack gap="200">
                  <InlineStack align="space-between" blockAlign="center">
                    <Text variant="headingMd">Tags</Text>
                  </InlineStack>
                  <InlineStack align="space-between" blockAlign="start">
                    <InlineStack align="start" gap="200" blockAlign="center">
                      <BucketButton horizontal={true} creator={profileData} changeBucketIndex={changeBuckets} setChangeBucketIndex={setChangeBuckets} handleCreateBucket={() => setManageBucketsOpen(true)} />
                    </InlineStack>
                  </InlineStack>
                </BlockStack>
              </Card>
              {
                /*
                <Card>
                  <BlockStack gap="500">
                    <Text variant="headingMd">Notes</Text>
                    {notesEditOpen ? (
                      <BlockStack gap="300">
                        <TextField value={localNotes} onChange={v => setLocalNotes(v)} multiline={2} />
                        <ButtonGroup>
                          <Button loading={savingNotes} icon={CheckIcon} onClick={() => saveProfileChange('notes')}>Save</Button>
                          <Button onClick={() => setNotesEditOpen(false)}>Cancel</Button>
                        </ButtonGroup>
                      </BlockStack>
                    ) : (
                        <InlineStack blockAlign="center" align="space-between">
                          {
                          profileData?.notes ? (
                            <Text variant="bodyMd">{profileData?.notes}</Text>
                          ) : <Text>None Yet</Text>
                        }
                          <Button size="slim" onClick={() => setNotesEditOpen(true)}>Edit</Button>
                        </InlineStack>
                      )}
                  </BlockStack>
                </Card>
  */
              }
              {Object.keys(profileData?.customFields || {})?.length ? (
                <Card>
                  <BlockStack gap="500">
                    <Text variant="headingMd">Custom Fields</Text>
                    <BlockStack gap="500">
                      {
                        Object.entries(profileData?.customFields)?.map(([key, value], i) => (
                          <BlockStack gap="300" key={i}>
                            <BlockStack gap="100">
                              <Text variant="bodyMd">{key}</Text>
                              <Text color="subdued" variant="bodyMd">{value}</Text>
                            </BlockStack>
                            <Divider />
                          </BlockStack>
                        ))
                      }
                    </BlockStack>
                  </BlockStack>
                </Card>
              ) : null}
              {
                profileData?.hashtags?.length ? (
                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingSm">Hashtags</Text>
                      <InlineStack align="start" gap="100">
                        {
                          profileData?.hashtags?.slice(0, 7).map((h, index) => (
                            <Tag key={index}>#{h.tag}</Tag>
                          ))
                        }
                      </InlineStack>
                    </BlockStack>
                  </Card>
                ) : null
              }
            </InlineGrid>
          </BlockStack>
          <BlockStack gap="500">
            <Text variant="headingLg">Audience</Text>
            <InlineGrid columns={{ xs: "1", md: "3" }} gap="500" alignItems="start">
              <StatsCard icon={PersonIcon} title="Followers" value={shortenNumber(profileData?.followers)} subValue={
                <Badge>
                  <InlineStack gap="100">
                    <Link onClick={() => setCustomerFiltersOpen(true)} removeUnderline>
                      {shortenNumber(targetFollowers)} Qualified ({(targetFollowers / profileData?.followers * 100)?.toFixed(0) + '%'})
                    </Link>
                  </InlineStack>
                </Badge>

              } />
              <StatsCard icon={SmileyJoyIcon} title="Engagement" value={(profileData?.engagementRate * 100).toFixed(2) + '%'} />
              {
                profileData?.platform === 'instagram' ? (
                  <StatsCard icon={PlayIcon} title="Avg Reel Plays" value={shortenNumber(profileData?.avgReelsPlays)} />
                ) : profileData?.avgViews ? (
                  <StatsCard icon={PlayIcon} title="Avg Views" value={shortenNumber(profileData?.profile?.averageViews)} />
                ) : null
              }
              {
                profileData?.platform === 'instagram' ? (
                  <StatsCard icon={PersonRemoveIcon} title="Fake Followers" value={profileData?.credibility ? ((1 - profileData?.credibility) * 100).toFixed(2) + '%' : '-'} />
                ) : profileData?.postsCount ? (
                  <StatsCard icon={ImagesIcon} title="Post Count" value={profileData?.postsCount} />
                ) : null
              }
              {
                profileData?.avgLikes ? (
                  <StatsCard icon={HeartIcon} title="Avg Likes" value={shortenNumber(profileData?.avgLikes)} />
                ) : null
              }
              {
                profileData?.avgComments ? (
                  <StatsCard icon={ChatIcon} title="Avg Comments" value={shortenNumber(profileData?.avgComments)} />
                ) : null
              }
            </InlineGrid>
            <InlineGrid columns={{ xs: "1", md: "3" }} gap="500">
              <Card>
                <BlockStack gap="100">
                  <Text variant="headingSm">Genders</Text>
                  {
                    profileData?.genders?.map((gender, index) => (
                      <InlineStack align="space-between" key={index}>
                        <Text>{gender.code}</Text>
                        <Text>{(gender.weight * 100)?.toFixed(2)}%</Text>
                      </InlineStack>
                    ))
                  }
                </BlockStack>
              </Card>
              <Card>
                <BlockStack gap="100">
                  <Text variant="headingSm">Countries</Text>
                  {
                    profileData?.geoCountries?.map((country, index) => (
                      <InlineStack align="space-between" key={index}>
                        <Text>{getCountry(country.code, true)} {country.name}</Text>
                        <Text>{(country.weight * 100)?.toFixed(2)}%</Text>
                      </InlineStack>
                    ))
                  }
                </BlockStack>
              </Card>
              <Card>
                <BlockStack gap="100">
                  <Text variant="headingSm">Ages</Text>
                  {
                    profileData?.ages?.map((age, index) => (
                      <InlineStack align="space-between" key={index}>
                        <Text>{age.code}</Text>
                        <Text>{(age.weight * 100)?.toFixed(2)}%</Text>
                      </InlineStack>
                    ))
                  }
                </BlockStack>
              </Card>
            </InlineGrid>
          </BlockStack>
        </InlineGrid>
      </BlockStack>
    </>
  )

}
